import React, {FC} from 'react';
import GoogleIcon from 'components/icons/GoogleIcon';

import Stars from './Stars';

import './index.scss';

export interface IUserReviewsItemProps {
    rating: string;
    userFeedback: string;
    userFeedbackProvider: string;
    userName: string;
}

const UserReviewsItem: FC<IUserReviewsItemProps> = ({rating, userFeedback, userName, userFeedbackProvider}) => {
	const provider = () => {
		switch (userFeedbackProvider) {
		case 'google':
			return <GoogleIcon />;
		default:
			return userFeedbackProvider;
		}
	};

	return (
		<div className='user-review-item'>
			<div className='user-review-item--content'>
				<Stars rating={Number(rating)} />
				<div className='user-review-item--content--feedback'>
					{userFeedback}
				</div>
				<div className='user-review-item--content--source'>
					{provider()}
				</div>
			</div>
			<div className='user-review-item--userName'>
				{userName}
			</div>
		</div>
	);
};

export default UserReviewsItem;
